import { getVisualization } from './fft/get-visualization'
import { getMaxPossibleMagnitude } from './fft/max-value-cached'

const cache = {}

const visualizeAudioFrame = ({
  audioData: metadata,
  position,
  numberOfSamples
}) => {
  const cacheKey = metadata.resultId + position + numberOfSamples
  if (cache[cacheKey]) {
    return cache[cacheKey]
  }

  const maxInt = getMaxPossibleMagnitude(metadata)

  return getVisualization({
    sampleSize: numberOfSamples * 2,
    data: metadata.channelWaveforms[0],
    position,
    sampleRate: metadata.sampleRate,
    maxInt
  })
}

export const visualizeAudio = ({ smoothing = true, ...parameters }) => {
  if (!smoothing) {
    return visualizeAudioFrame(parameters)
  }

  const frame = Math.round(parameters.position)

  const toSmooth = [frame - 1, frame, frame + 1]
  const all = toSmooth.map(s => {
    return visualizeAudioFrame({ ...parameters, frame: s })
  })
  return new Array(parameters.numberOfSamples).fill(true).map((x, i) => {
    return (
      new Array(toSmooth.length)
        .fill(true)
        .map((_, j) => {
          return all[j][i]
        })
        .reduce((a, b) => a + b, 0) / toSmooth.length
    )
  })
}
